import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=3858a663&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=3858a663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3858a663",
  null
  
)

export default component.exports